var exports = {
  "k": "container__HcSdal",
  "Q": "text__bRI4_Q",
};

module.exports = exports;
